import React from "react";
import logo from "../../assets/cycle-logo.png"; // <-- YOUR TOKEN LOGO
// make sure logo.png exists in /src/assets/

export default function Navbar() {
  const CONTRACT = process.env.REACT_APP_DEX_TOKEN || "";

  const copyCA = () => {
    navigator.clipboard.writeText(CONTRACT);
    alert("Contract Address Copied!");
  };

  return (
    <div className="w-full h-16 bg-primary flex items-center justify-between px-6 shadow-md">
      
      {/* LEFT: LOGO */}
      <div className="flex items-center space-x-3 cursor-pointer">
        <img
          src={logo}
          alt="CYCLE"
          className="h-14 w-14 object-contain"
        />
      </div>

      {/* RIGHT: COPY CONTRACT */}
      <button
        onClick={copyCA}
        className="bg-[#14F195] hover:bg-[#9945ff] text-black px-4 py-2 rounded font-DMSans text-sm shadow-md transition"
      >
        CA: {CONTRACT.slice(0, 4)}...{CONTRACT.slice(-4)}
      </button>
    </div>
  );
}
